// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "assets/" + "vendors" + "-" + "47cbc5f9e9351376267d" + ".css";
};